import React from "react";
import {
  Divider,
  Grid,
} from "@mui/material";
import {
  InstanceParametersType,
} from "../../redux/api/api.types";
import InstanceContactRow from "./InstanceContactRow";

export default function InstanceAdminDataTable (data: InstanceParametersType) {
  const renderContactTable = ({ django }: InstanceParametersType) => {
    const {cuemail, cufirstname, culastname} = django;
    return InstanceContactRow({
      rowEmail: cuemail || "-",
      rowFirst: cufirstname || "-",
      rowLast: culastname || "-"
    })
  }
  return (
    <>
      <Grid item xs={12}> 
        <Divider orientation="horizontal" flexItem/>
      </Grid>
      {InstanceContactRow({
        rowEmail: "Contact Email",
        rowFirst: "Contact First Name",
        rowLast: "Contact Last Name"
      }, true)}
      {renderContactTable(data)}
    </>
  );
}